import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import { parseISO } from 'date-fns'
import { useCaseHistory } from '~/entities/case'
import { Loader } from '~/shared/ui'
import { getDueDateLabel } from '~/shared/lib/dateLabels'
import { formatDisplayDate } from '~/shared/lib/date'

export const CaseHistory = (props: { id: number }) => {
  const { isPending: isLoading, data } = useCaseHistory(props.id)

  if (isLoading || !data) {
    return <Loader />
  }

  const { results } = data

  // Format change values - uses formatDisplayDate for date fields
  const formatChangeValue = (field: string, value: string | null): string => {
    if (value === null) return '(empty)'
    // Format date fields (Due Date) - values come as ISO strings
    if (field === 'Due Date' && value) {
      return formatDisplayDate(value)
    }
    return value
  }

  return (
    <List>
      {results?.map(event => (
        <ListItem key={event.id}>
          <ListItemText>
            <Typography sx={{ fontWeight: 'bold' }}>
              {getDueDateLabel(parseISO(event.timestamp))} - {event.action}
              {event.user ? ` by ${event.user.first_name} ${event.user.last_name}` : null}
            </Typography>
            {event.changes.length > 0 ? (
              <Box component="ul" sx={{ mt: 1, pl: 2 }}>
                {event.changes.map((change, idx) => (
                  <li key={idx}>
                    <Typography variant="body2">
                      <strong>{change.field}:</strong>{' '}
                      {formatChangeValue(change.field, change.from_value)} →{' '}
                      {formatChangeValue(change.field, change.to_value)}
                    </Typography>
                  </li>
                ))}
              </Box>
            ) : null}
          </ListItemText>
        </ListItem>
      ))}
    </List>
  )
}
